export type CriteriaType = "env:production" | "env:nonProduction" | "env:all";

export interface CriteriaObject {
  id: CriteriaType;
  check(): boolean;
}

const COLOR_ENV = process.env.NEXT_PUBLIC_COLOR_ENV;

const criteriaList: CriteriaObject[] = [
  {
    id: "env:production",
    check: () => {
      return COLOR_ENV === "production";
    },
  },
  {
    id: "env:nonProduction",
    check: () => {
      return COLOR_ENV !== "production";
    },
  },
  {
    id: "env:all",
    check: () => {
      return true;
    },
  },
];

export default criteriaList;
